// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Auth_content__l8f7v {
  width: 40vw;
  max-width: 366px;
  background-color: #FFFFFF;
  margin: 0 auto;
  font-size: 12px;
  font-weight: 300;
  line-height: 20px;
}

.Auth_title__iUmpU {
  font-weight: 500;
  color: #00007A;
  font-size: 20px;
  text-align: center;
  margin-bottom: 30px;
}

.Auth_text__IsIN3 {
  text-align: center;
  font-weight: 300;
  font-size: 14px;
  margin: -15px 0 30px 0;
}

.Auth_message__eDN5t {
  padding: 4px 8px;
}

.Auth_error__jgNyc {
  font-size: 12px;
  font-weight: 300;
}
.Auth_error__jgNyc > p {
  margin: 10px 0 5px;
}
.Auth_error__jgNyc div {
  height: auto;
}
.Auth_error__jgNyc svg {
  height: 15px;
  vertical-align: middle;
}

.Auth_link__IT-yi a {
  font-size: 12px;
  text-decoration: underline;
  color: #121217 !important;
  font-weight: 300;
}

.Auth_resend__Guamb {
  display: block;
  text-align: center;
  margin-top: 15px;
}

.Auth_response__DzAzp {
  padding-bottom: 0;
  margin-bottom: 20px;
}

.Auth_button__KPJug {
  width: 167px;
  height: 40px;
  display: block;
  margin: 30px auto 0;
  padding: 0;
  border-radius: 24px;
  background-color: #00007A;
  color: #FFFFFF;
}
.Auth_button__KPJug:disabled {
  background-color: #D8D8FF;
}

.Auth_eyeOpen__ywhkq path {
  stroke: #838390;
}

.Auth_eyeClosed__twQ9H path {
  fill: #838390;
}

.Auth_logo__o7gaz {
  text-align: center;
  margin-bottom: 20px;
}
.Auth_logo__o7gaz svg {
  width: 85px !important;
  height: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/reporting/pages/Auth/Auth.module.scss","webpack://./src/components/reporting/styles/colors.scss"],"names":[],"mappings":"AAEA;EACI,WAAA;EACA,gBAAA;EACA,yBCJI;EDKJ,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAmBJ;;AAhBA;EACI,gBAAA;EACA,cCLI;EDMJ,eAAA;EACA,kBAAA;EACA,mBAAA;AAmBJ;;AAhBA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AAmBJ;;AAhBA;EACI,gBAAA;AAmBJ;;AAhBA;EACI,eAAA;EACA,gBAAA;AAmBJ;AAjBI;EACI,kBAAA;AAmBR;AAhBI;EACI,YAAA;AAkBR;AAhBI;EACI,YAAA;EACA,sBAAA;AAkBR;;AAdA;EACI,eAAA;EACA,0BAAA;EACA,yBAAA;EACA,gBAAA;AAiBJ;;AAdA;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;AAiBJ;;AAdA;EACI,iBAAA;EACA,mBAAA;AAiBJ;;AAdA;EACI,YAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;EACA,yBChEI;EDiEJ,cCzEI;AD0FR;AAfI;EACI,yBChEA;ADiFR;;AAbA;EACI,eC9EI;AD8FR;;AAdA;EACI,aCjFI;ADkGR;;AAdA;EACI,kBAAA;EACA,mBAAA;AAiBJ;AAfI;EACI,sBAAA;EACA,YAAA;AAiBR","sourcesContent":["@use 'components/reporting/styles/colors.scss';\n\n.content {\n    width: 40vw;\n    max-width: 366px;\n    background-color: colors.$light;\n    margin: 0 auto;\n    font-size: 12px;\n    font-weight: 300;\n    line-height: 20px;\n}\n\n.title{\n    font-weight: 500;\n    color: colors.$blue1;\n    font-size: 20px;\n    text-align: center;\n    margin-bottom: 30px;\n}\n\n.text{\n    text-align: center;\n    font-weight: 300;\n    font-size: 14px;\n    margin: -15px 0 30px 0;\n}\n\n.message{\n    padding: 4px 8px;\n}\n\n.error{\n    font-size: 12px;\n    font-weight: 300;\n    \n    > p{\n        margin: 10px 0 5px;\n    }\n\n    div{\n        height: auto;\n    }\n    svg{\n        height: 15px;\n        vertical-align: middle;\n    }\n}\n\n.link a{\n    font-size: 12px;\n    text-decoration: underline;\n    color: colors.$dark!important;\n    font-weight: 300;\n}\n\n.resend{\n    display: block;\n    text-align: center;\n    margin-top: 15px;\n}\n\n.response{\n    padding-bottom: 0;\n    margin-bottom: 20px;\n}\n\n.button{\n    width: 167px;\n    height: 40px;\n    display: block;\n    margin: 30px auto 0;\n    padding: 0;\n    border-radius: 24px;\n    background-color: colors.$blue1;\n    color: colors.$light;\n\n    &:disabled{\n        background-color: colors.$blue5;\n    }\n}\n\n.eyeOpen path{\n    stroke: colors.$grey2;\n}\n.eyeClosed path{\n    fill: colors.$grey2;\n}\n\n.logo{\n    text-align: center;\n    margin-bottom: 20px;\n\n    svg{\n        width: 85px!important;\n        height: auto;\n    }\n}","$dark: #121217;\n$light: #FFFFFF;\n\n$grey1: #3E3E50;\n$grey2: #838390;\n$grey3: #C3C3C9;\n$grey4: #E0E0E3;\n$grey5: #F9F9FA;\n\n$blue1: #00007A;\n$blue2: #0000C9;\n$blue3: #4343FF;\n$blue4: #8686FF;\n$blue5: #D8D8FF;\n$blueLogo: #000093;\n\n$orange1: #DA8200;\n$orange2: #FFA92C;\n$orange3: #FFC26B;\n$orange4: #FFE1B7;\n$orange5: #FFF3E3;\n\n$green1: #033E0F;\n$green2: #218214;\n$green3: #58B441;\n$green4: #89D96B;\n$green5: #E1F8CE;\n\n$brick1: #7D1F01;\n$brick2: #B94402;\n$brick3: #E78D3D;\n$brick4: #FBD298;\n$brick5: #FDEBCB;\n\n$red1: #540726;\n$red2: #7C1028;\n$red3: #BD454A;\n$red4: #F4ADA1;\n$red5: #F9D9CF;\n\n\n:export {\n    light: $light;\n    dark: $dark;\n    blue1: $blue1;\n    blue2: $blue2;\n    blue3: $blue3;\n    blue4: $blue4;\n    blue5: $blue5;\n    orange1: $orange1;\n    orange2: $orange2;\n    orange3: $orange3;\n    orange4: $orange4;\n    orange5: $orange5;\n    grey1: $grey1;\n    grey2: $grey2;\n    grey3: $grey3;\n    grey4: $grey4;\n    grey5: $grey5;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"light": `#FFFFFF`,
	"dark": `#121217`,
	"blue1": `#00007A`,
	"blue2": `#0000C9`,
	"blue3": `#4343FF`,
	"blue4": `#8686FF`,
	"blue5": `#D8D8FF`,
	"orange1": `#DA8200`,
	"orange2": `#FFA92C`,
	"orange3": `#FFC26B`,
	"orange4": `#FFE1B7`,
	"orange5": `#FFF3E3`,
	"grey1": `#3E3E50`,
	"grey2": `#838390`,
	"grey3": `#C3C3C9`,
	"grey4": `#E0E0E3`,
	"grey5": `#F9F9FA`,
	"content": `Auth_content__l8f7v`,
	"title": `Auth_title__iUmpU`,
	"text": `Auth_text__IsIN3`,
	"message": `Auth_message__eDN5t`,
	"error": `Auth_error__jgNyc`,
	"link": `Auth_link__IT-yi`,
	"resend": `Auth_resend__Guamb`,
	"response": `Auth_response__DzAzp`,
	"button": `Auth_button__KPJug`,
	"eyeOpen": `Auth_eyeOpen__ywhkq`,
	"eyeClosed": `Auth_eyeClosed__twQ9H`,
	"logo": `Auth_logo__o7gaz`
};
export default ___CSS_LOADER_EXPORT___;
